import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useLabel } from '@react-aria/label';
import { useId } from '@react-aria/utils';
import { Fragment, useCallback, useRef } from 'react';
import { isBoolean, isFormValidationErrorDisplayed } from '../../common.types.js';
import { BKJTextInputFieldSet, BKJTextInputLabel, BKJTextInputRequiredAsterisk, } from '../BKJTextInput/BKJTextInput.styled.js';
import { BKJFileInputLabel, BKJFileInputText, CloseIcon, DocumentIcon, ErrorText, FileWrapper, InnerWrapper, Input, } from './BKJFileInput.styled.js';
import i18next from 'i18next';
export const BKJFileInput = (props) => {
    const { className, labelProps: consumerLabelProps, label, required, name, disabled, error, value, onChange = () => { }, onClear, ...rest } = props;
    const inputRef = useRef();
    const hasStringyError = isFormValidationErrorDisplayed(error) && !isBoolean(error);
    const errorId = useId();
    const { labelProps, fieldProps } = useLabel({
        label: label || 'File upload',
    });
    const handleChange = useCallback((event) => {
        const selectedFile = event?.target?.files && event.target.files[0];
        if (selectedFile) {
            onChange({
                target: { ...event.target, name, value: selectedFile },
            });
        }
    }, [name, onChange]);
    const handleClear = (e) => {
        e.stopPropagation();
        onChange({ target: { value: undefined, name } });
        if (inputRef.current) {
            inputRef.current.value = '';
        }
        if (onClear)
            onClear();
    };
    const handleClearKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleClear(e);
        }
    };
    return (_jsxs(BKJTextInputFieldSet, { children: [label && (_jsxs(BKJTextInputLabel, { ...consumerLabelProps, ...labelProps, variant: "RoundEdges", elementType: "Label", children: [label, required && _jsx(BKJTextInputRequiredAsterisk, { children: "\u00A0*" })] })), _jsxs(InnerWrapper, { error: !!error, children: [value && (_jsx(CloseIcon, { iconName: "CloseBold", onClick: handleClear, role: "button", tabIndex: 0, "aria-label": "Clear file", onKeyDown: handleClearKeyDown })), _jsxs(FileWrapper, { isFileSelected: !!value, children: [_jsx(DocumentIcon, { iconName: "Document" }), _jsx(BKJFileInputText, { title: value && value.name, error: !!error, isFileSelected: !!value, children: !!value ? value.name : i18next.t('translations:NO_FILE_SELECTED') }), _jsx(Input, { ...rest, ...fieldProps, ref: inputRef, type: "file", onChange: handleChange, "aria-invalid": isFormValidationErrorDisplayed(error) ? true : undefined, "aria-describedby": hasStringyError ? errorId : undefined, "aria-required": required || undefined, disabled: disabled })] }), _jsx(BKJFileInputLabel, { type: "button", onClick: () => inputRef.current?.click(), disabled: disabled, children: !!value ? i18next.t('translations:REPLACE') : i18next.t('translations:SELECT_A_FILE') })] }), hasStringyError && (_jsx(ErrorText, { id: errorId, children: Array.isArray(error)
                    ? error.map((err, i) => (_jsxs(Fragment, { children: [i > 0 && _jsx("br", {}), err] }, `${err}-${i}`)))
                    : error }))] }));
};
//# sourceMappingURL=BKJFileInput.js.map